@use "@fukuri-admins/ui/layout" as *;

.table {
  border: 1px solid border('Tertiary');
  border-radius: borderRadius('lg');
  overflow: hidden;
  width: 100%;
  display: flex;
  flex-direction: column;

  // 最終行の td は外枠の下辺 border と重なるため border-bottom を消す
  tbody tr:last-child td {
    border-bottom: none;
  }
}

// scrollable=true 時に横スクロールを有効化する
// .table の overflow: hidden を .table.scrollable で上書き（複合セレクタで specificity を上げて確実に上書き）
// display: block に切り替えて flex による align-items: stretch の影響を回避し、内部 <table> がコンテナ幅を超えてオーバーフローできるようにする
.table.scrollable {
  overflow-x: auto;
  overflow-y: hidden;
  display: block;

  // display: block により内部 <table> がコンテンツ幅まで縮むのを防ぐため、親幅まで広げる
  // 親より広い場合は <table> 本来の挙動でオーバーフローし、横スクロールが発生する
  > table {
    min-width: 100%;
  }
}

// fixedHeader=true 時に縦スクロールとヘッダー固定を有効化する
// scrollable と組み合わせると overflow-y: hidden を auto で上書きし、縦横両方スクロール可能になる
.table.fixedHeader {
  overflow-y: auto;
  display: block;

  > table {
    min-width: 100%;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 1;
  }
}

.tableFixed {
  table-layout: fixed;
  width: 100%;
}

.headRow {
  th {
    @include typography('Jp/14_W3');
    color: text('Low');
    background-color: background('Senary');
  }
}
